export const windowStyleOptions = [
  { id: 'isolated', text: 'Isolated', value: 'ISOLATED' },
  { id: 'wall_to_wall', text: 'Wall to wall', value: 'WALL_TO_WALL' },
] as any[];
export const WindowStyleList = windowStyleOptions.map((x) => x.value);
export type WindowStyle = typeof windowStyleOptions[number]['value'];
